import { render, staticRenderFns } from "./NewReview.vue?vue&type=template&id=dbdc8ab6"
import script from "./NewReview.vue?vue&type=script&lang=js"
export * from "./NewReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports